export default function removeReferrerUrl() {
  localStorage.removeItem('referrer');
}
